<template>
  <v-dialog v-model="visible" max-width="638" persistent>
    <v-card v-if="visible" class="v-dialog--custom">
      <v-card-title class="headline pa-4">
        <span class="v-dialog--custom__title">{{ $t(`${namespace}.title`) }}</span>
        <v-btn
          class="v-dialog--custom__close mr-2"
          color="gray-6"
          flat
          fab
          :disabled="isLoading"
          @click.native="close(null)"
        >
          <v-icon dark>close</v-icon>
        </v-btn>
      </v-card-title>

      <form
        class="form--custom"
        novalidate
        @submit.prevent="handleSubmit"
      >
        <v-card-text class="px-4 pt-0 pb-3">
          <p v-html="$t(`${namespace}.text`).replace('[COMPANY]', 'Nome da empresa')" />

          <v-layout>
            <v-flex xs6>
              <div class="pr-2--desktop">
                <label>{{ $t(`${namespace}.form.fieldBankLabel`) }}*</label>
                <v-text-field
                  v-model="form.bank"
                  :placeholder="$t(`${namespace}.form.fieldBankPlaceholder`)"
                  :error-messages="errors.collect($t(`${namespace}.form.fieldBankName`))"
                  v-validate="{ required: true }"
                  :data-vv-name="$t(`${namespace}.form.fieldBankName`)"
                  required
                  flat
                  outline
                  solo
                  color="accent"
                />
              </div>
            </v-flex>

            <v-flex xs6>
              <div class="pl-2--desktop">
                <label>{{ $t(`${namespace}.form.fieldNumberOfBankLabel`) }}*</label>
                <v-text-field
                  v-model="form.numberOfBank"
                  :placeholder="$t(`${namespace}.form.fieldNumberOfBankPlaceholder`)"
                  :error-messages="errors.collect($t(`${namespace}.form.fieldNumberOfBankName`))"
                  v-validate="{ required: true, integer: true }"
                  :data-vv-name="$t(`${namespace}.form.fieldNumberOfBankName`)"
                  required
                  flat
                  outline
                  solo
                  color="accent"
                />
              </div>
            </v-flex>
          </v-layout>

          <v-layout>
            <v-flex xs4>
              <div class="pr-2--desktop">
                <label>{{ $t(`${namespace}.form.fieldBranchLabel`) }}*</label>
                <v-text-field
                  v-model="form.branch"
                  :placeholder="$t(`${namespace}.form.fieldBranchPlaceholder`)"
                  :error-messages="errors.collect($t(`${namespace}.form.fieldBranchName`))"
                  v-validate="{ required: true, integer: true }"
                  :data-vv-name="$t(`${namespace}.form.fieldBranchName`)"
                  required
                  flat
                  outline
                  solo
                  color="accent"
                />
              </div>
            </v-flex>

            <v-flex xs4>
              <div class="pl-2--desktop pr-2--desktop">
                <label>{{ $t(`${namespace}.form.fieldBankAccountLabel`) }}*</label>
                <v-text-field
                  v-model="form.bankAccount"
                  :placeholder="$t(`${namespace}.form.fieldBankAccountPlaceholder`)"
                  :error-messages="errors.collect($t(`${namespace}.form.fieldBankAccountName`))"
                  v-validate="{ required: true, integer: true }"
                  :data-vv-name="$t(`${namespace}.form.fieldBankAccountName`)"
                  required
                  flat
                  outline
                  solo
                  color="accent"
                />
              </div>
            </v-flex>

            <v-flex xs4>
              <div class="pl-2--desktop">
                <label>{{ $t(`${namespace}.form.fieldDigitLabel`) }}*</label>
                <v-text-field
                  v-model="form.digit"
                  :placeholder="$t(`${namespace}.form.fieldDigitPlaceholder`)"
                  :error-messages="errors.collect($t(`${namespace}.form.fieldDigitName`))"
                  v-validate="{ required: true, integer: true }"
                  :data-vv-name="$t(`${namespace}.form.fieldDigitName`)"
                  required
                  flat
                  outline
                  solo
                  color="accent"
                />
              </div>
            </v-flex>
          </v-layout>

          <v-layout>
            <v-flex xs6>
              <div class="pr-2--desktop">
                <label>{{ $t(`${namespace}.form.fieldReceiptMethodLabel`) }}*</label>
                <v-text-field
                  v-model="form.receiptMethod"
                  :placeholder="$t(`${namespace}.form.fieldReceiptMethodPlaceholder`)"
                  :error-messages="errors.collect($t(`${namespace}.form.fieldReceiptMethodName`))"
                  v-validate="{ required: true }"
                  :data-vv-name="$t(`${namespace}.form.fieldReceiptMethodName`)"
                  required
                  flat
                  outline
                  solo
                  color="accent"
                />
              </div>
            </v-flex>

            <v-flex xs6>
              <div class="pl-2--desktop">
                <label>{{ $t(`${namespace}.form.fieldAccountingInSapLabel`) }}*</label>
                <v-text-field
                  v-model="form.accountingInSap"
                  :placeholder="$t(`${namespace}.form.fieldAccountingInSapPlaceholder`)"
                  :error-messages="errors.collect($t(`${namespace}.form.fieldAccountingInSapName`))"
                  v-validate="{ required: true }"
                  :data-vv-name="$t(`${namespace}.form.fieldAccountingInSapName`)"
                  required
                  flat
                  outline
                  solo
                  color="accent"
                />
              </div>
            </v-flex>
          </v-layout>

          <label>{{ $t(`${namespace}.form.fieldReasonLabel`) }}</label>
          <v-textarea
            v-model="form.reason"
            :placeholder="$t(`${namespace}.form.fieldReasonPlaceholder`)"
            :error-messages="errors.collect($t(`${namespace}.form.fieldReasonName`))"
            v-validate="{ max: 200 }"
            :data-vv-name="$t(`${namespace}.form.fieldReasonName`)"
            flat
            outline
            solo
            counter="200"
            color="accent"
          />
        </v-card-text>

        <v-divider />

        <v-card-actions class="pa-4">
          <v-spacer/>

          <a
            v-if="!isLoading"
            href="#"
            class="text--normal accent--text mr-4"
            color="accent"
            flat
            round
            @click.prevent="close(null)"
          >
            {{ $t('Common.cancel') }}
          </a>

          <v-btn
            type="submit"
            :loading="isLoading"
            :disabled="isLoading"
            color="accent"
            depressed
            round
          >
            {{ $t(`${namespace}.confirm`) }}
          </v-btn>
        </v-card-actions>
      </form>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'ApprovePaymentDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    data: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      namespace: 'Views.PaymentStatusPage.approvePaymentDialog',
      isLoading: false,
      form: {
        bank: null,
        numberOfBank: null,
        branch: null,
        bankAccount: null,
        digit: null,
        receiptMethod: null,
        accountingInSap: null,
        reason: null
      }
    }
  },
  methods: {
    ...mapActions({
      showAlert: 'snackbar/show'
    }),

    close (reload = null) {
      this.$emit('close', reload)
    },

    async handleSubmit () {
      this.isLoading = true

      try {
        const isValid = await this.$validator.validateAll()

        if (isValid) {
          const { data: res } = await this.$apiService.updateOrderStatus(this.data.numericalId, { ...this.form })

          if (res && !res.valid) {
            throw new Error()
          }

          this.close(true)
          this.showAlert({
            type: 'success',
            message: this.$t(`${this.namespace}.success`)
          })
        }
      } catch (err) {
        this.showAlert({
          type: 'error',
          message: this.$t(`${this.namespace}.error`)
        })
      }

      this.isLoading = false
    }
  }
}
</script>
